import { render, staticRenderFns } from "./DownloadSbb.vue?vue&type=template&id=a54c638e&scoped=true"
import script from "./DownloadSbb.vue?vue&type=script&lang=js"
export * from "./DownloadSbb.vue?vue&type=script&lang=js"
import style0 from "./DownloadSbb.vue?vue&type=style&index=0&id=a54c638e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a54c638e",
  null
  
)

export default component.exports